/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const DeleteEmployerTeammateType = {
    Employer: 'Employer',
    Invite: 'Invite'
};
export function instanceOfDeleteEmployerTeammateType(value) {
    for (const key in DeleteEmployerTeammateType) {
        if (Object.prototype.hasOwnProperty.call(DeleteEmployerTeammateType, key)) {
            if (DeleteEmployerTeammateType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function DeleteEmployerTeammateTypeFromJSON(json) {
    return DeleteEmployerTeammateTypeFromJSONTyped(json, false);
}
export function DeleteEmployerTeammateTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function DeleteEmployerTeammateTypeToJSON(value) {
    return value;
}
export function DeleteEmployerTeammateTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
